export function getVideoSessionFromTags(tags: string[]): string {
  const tagWithVideoSession = tags.find((elem) =>
    elem.includes('_videosession_'),
  );

  if (!tagWithVideoSession) {
    throw new Error('no tag with videosession in file data');
  }

  const videoSession = tagWithVideoSession.match(/\d+/);

  if (!videoSession) {
    throw new Error('no video session data in tag');
  }

  return videoSession[0];
}
